// extracted by mini-css-extract-plugin
export var o_hero = "hero-module--o_hero--a022e";
export var o_hero__bg = "hero-module--o_hero__bg--6d73b";
export var o_hero__bg2 = "hero-module--o_hero__bg2--4e29b";
export var o_hero__bgcolor = "hero-module--o_hero__bgcolor--f8092";
export var o_hero__btn = "hero-module--o_hero__btn--9efc3";
export var o_hero__container = "hero-module--o_hero__container--3bde8";
export var o_hero__desc = "hero-module--o_hero__desc--92272";
export var o_hero__img = "hero-module--o_hero__img--64d37";
export var o_hero__img2 = "hero-module--o_hero__img2--bf973";
export var o_hero__info = "hero-module--o_hero__info--4c772";
export var o_hero__media = "hero-module--o_hero__media--269c4";
export var o_hero__slide = "hero-module--o_hero__slide--0ceb5";
export var o_hero__slider = "hero-module--o_hero__slider--f2909";
export var o_hero__subtitle = "hero-module--o_hero__subtitle--c3899";
export var o_hero__title = "hero-module--o_hero__title--42a5b";